module.exports = __webpack_public_path__ + "img/banner-iptu-2022.762f05fc.jpg";